import { API_CALL, API_CALL_SUCCESS, API_CALL_ERROR } from '../constants/actionTypes';

const activeApiCalls = (state = 0, action) => {
    switch (action.type) {
    case API_CALL:
        return state + 1;
    case API_CALL_SUCCESS:
    case API_CALL_ERROR:
	    return state - 1;
    default:
        return state;
    }
};



export const getActiveApiCalls = state => state.activeApiCalls;

export default activeApiCalls;
